import React from 'react';
import { ISearchOptionLandRegister } from '../../../Interfaces/Helper/ISearchOptionLandRegister';
import { ICourt } from '../../../Interfaces/ICourt';
import { ICourtAdminstrativeUnitAssignment } from '../../../Interfaces/ICourtAdminstrativeUnitAssignment';
import { Card, CardContent, Grid, MenuItem, Typography } from '@mui/material';
import { CustomeTextField } from '../../../generic/CustomeTextField';

interface IProps {
  search: ISearchOptionLandRegister;
  setSearch: Function;
  courts: ICourt[];
  adminUnits: ICourtAdminstrativeUnitAssignment[];
}

export const QueryLandRegisterDownload: React.FC<IProps> = ({
  search,
  setSearch,
  courts,
  adminUnits,
}) => {
  return (
    <>
      <Card variant='outlined' sx={{ mt: 2 }}>
        <Typography variant='caption' sx={{ ml: 1 }}>
          Beziehen
        </Typography>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <CustomeTextField
                label='Gericht'
                attr='idCourt'
                object={search}
                setObject={(updatedSearch: ISearchOptionLandRegister) => {
                  setSearch({
                    ...updatedSearch,
                    idAdministrativeUnit: null,
                  });
                }}
                type='select'
                null={true}
              >
                {courts
                  .filter(
                    court => court.idFederalState === search.idFederalState
                  )
                  .map(court => (
                    <MenuItem
                      key={`select-court-${court.idCourt}`}
                      value={court.idCourt}
                    >
                      {court.Court}
                    </MenuItem>
                  ))}
              </CustomeTextField>
            </Grid>
            <Grid item xs={4}>
              <CustomeTextField
                label='Gemarkung'
                attr='idAdministrativeUnit'
                object={search}
                setObject={(updatedSearch: ISearchOptionLandRegister) => {
                  if (updatedSearch.idCourt === null) {
                    const testAdminUnit = adminUnits.find(
                      admin =>
                        admin.idAdministrativeUnit ===
                        updatedSearch.idAdministrativeUnit
                    );
                    if (testAdminUnit) {
                      setSearch({
                        ...updatedSearch,
                        idCourt: testAdminUnit.idCourt,
                        idAdministrativeUnit:
                          testAdminUnit.idAdministrativeUnit,
                      });
                    }
                  } else {
                    setSearch({
                      ...updatedSearch,
                      idAdministrativeUnit: updatedSearch.idAdministrativeUnit,
                    });
                  }
                }}
                type='select'
                null={search.idAdministrativeUnit === null}
              >
                {adminUnits
                  .filter(
                    adminUnit =>
                      adminUnit.idCourt === search.idCourt ||
                      search.idCourt === null
                  )
                  .sort((a, b) =>
                    String(a.AdministrativeUnit) < String(b.AdministrativeUnit)
                      ? -1
                      : 1
                  )
                  .map(adminUnit => (
                    <MenuItem
                      key={`select-adminUnit-${adminUnit.idAdministrativeUnit}`}
                      value={adminUnit.idAdministrativeUnit}
                    >
                      {search.idCourt === null
                        ? `${adminUnit.AdministrativeUnit}, Gericht ${adminUnit.Court}`
                        : adminUnit.AdministrativeUnit}
                    </MenuItem>
                  ))}
              </CustomeTextField>
            </Grid>
            <Grid item xs={4}>
              <CustomeTextField
                label='BlattNr.'
                attr='SheetLandRegister'
                object={search}
                setObject={(updatedSearch: ISearchOptionLandRegister) => {
                  setSearch({
                    ...updatedSearch,
                  });
                }}
                type='string'
                null={search.SheetLandRegister === null}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};
